<template>
  <div class="home">
    <h1>Policies</h1>
        <h3>Some links:</h3>
        <ul>
            <li>The full syllabus can be found <a href="syllabus.pdf" target="_blank">here (link)</a>.</li>
            <li><a href="https://www.mines.edu/student-life/student-absences/" target="_blank">Excused absence policy (link)</a></li>
            <li><a href="http://inside.mines.edu/UserFiles/File/PoGo/Policies/STU/STU_Academic_Integrity.pdf" target="_blank">Policy on academic integrity/misconduct (link)</a></li>
        </ul>

        <h3>Grading</h3>
        <p>Programming assignments come in two flavors: <i>APTs</i> and <i>projects</i>. 
        APTs consist of small, automatically graded programs or bits of code, while projects 
        require you to program fully functional programs to accomplish some specified task. 
        Each Friday there will be a lab activity. There will be two midterm exams and a final. 
        Finally, a small percentage of your grade will be based on your participation in lab.</p>
        <p>Grading will be done on an absolute, but adjustable scale. This means that there is 
        no curve. Anyone earning 90% or more of the total number of points available will receive 
        a grade of A; 80% or higher a B, etc. This scale may go down, but it will not go up.</p>

        <p><b><i>Note: you must pass the final (60% or higher) to pass this course.</i></b></p>

        <p>All grades will be posted in Canvas.</p>
        <table class="lined-table">
            <tr>
                <td>Assignments:</td>
                <td>40%</td>
            </tr>
            <tr>
                <td>Labs: </td>
                <td> 10%</td>
            </tr>
            <tr>
                <td>Class participation: </td>
                <td> 5%</td>
            </tr>
            <tr>
                <td>Midterms: </td>
                <td> 20%</td>
            </tr>
            <tr>
                <td>Final exam: </td>
                <td> 25%</td>
            </tr>
        </table>
        <br/>

        <h3>Late policy</h3>
        <p>Late work is <i>strongly</i> discouraged. All work will be accepted within 4 working days after the deadline. Weekend and holiday days <b>do not</b> count in the 4 days, so if an assignment is due on Friday at midnight, then it will be considered one day late if turned in anytime after Friday at midnight and before Monday at midnight. Students will lose 10 percentage points per day late. After 4 days, the work will not be accepted at all. This applies to both regular assignments and lab assignments. Extensions are possible, but please ask well ahead of the deadline - not at the last moment!
        </p>

        <h3>Learning Environment</h3>
        <p>Below you can find some "official" language from Mines on similar topics, but I also want to share my own views regarding the learning environment as it relates to my course, both in and out of the classroom.</p>

        <p>Fundamentally, I expect and require respect in this course for yourself, your classmates, and your instructor and TAs.</p>

        <ul>
            <li>Respect for yourself includes taking care of yourself physically and mentally and advocating for an environment that facilitates learning for you. </li>
            <li>Respect for your classmates includes recognizing and appreciating the diversity of backgrounds and experiences of your classmates and making it your interest to foster a learning environment for everyone. Some of your classmates may already be expert programmers, while others may have only just begun to learn; all are welcome.</li>
            <li>Respect for your instructors (as well as your classmates) includes not participating in disruptive or distracting behavior: talking, playing games, or web surfing during lecture, for instance, make it difficult for others to focus on the reason we are all here.</li>
            <li>Respect must be mutual to be effective; we (your instructors) and your TAs will be held to the same standards of respect.</li>
        </ul>

        <p>It's important to recognize that the rigorous requirements of studying at Mines can cause stress, which sometimes results in distressed or disruptive behavior. If you are experiencing issues, or believe that one of your partners or teammates is, please SPEAK UP. Feel free to come talk to your instructor, or visit <a href="https://www.mines.edu/student-life/care/" target="_blank">CARE at Mines</a>. For serious violations of school policies, also see <a href="https://www.mines.edu/speak-up/" target="_blank">SpeakUP@Mines</a>.</p>


        <h3>Discrimination, Harassment, and Title IX</h3>
        <p>All learning opportunities at Mines, including this course,
require a safe environment for everyone to be productive and able to share and learn without fear of
discrimination or harassment. Mines’ core values of respect, diversity, compassion, and collaboration will
be honored in this course (more information can be found 
<a href="http://inside.mines.edu/UserFiles/File/FacultySenate/Documents/ValuesAndAspirationsStatement2-14-17.pdf" target="_blank">here</a>), and the standards in this class are the
same as those expected in any professional work environment. <b>Discrimination or harassment of any
type will not be tolerated.</b> As a participant in this course, we expect you to respect your instructor and
your classmates. As your instructors, it is our responsibility to foster a learning environment that supports
diversity of thoughts, perspectives and experiences, and honors your identities. To help accomplish this:</p>
<ul>
<li>Course rosters are provided to the instructor with the student’s legal name. We will honor your
request to address you by an alternate name or gender pronoun. Please advise us of this
preference early in the semester so that we may make appropriate changes to our records.</li>
<li>If something is said or done in this course (by anyone, including an instructor) that made you or others
feel uncomfortable, or if your performance in the course is being impacted by your experiences
outside of the course, please report it to:
<ul>
<li>The instructor or course coordinator (if you are comfortable doing so)</li>
<li>Wellness Center- Counseling (<a href="https://www.mines.edu/counseling-center/" target="_blank">https://www.mines.edu/counseling-center/</a>)</li>
<li>Speak Up (<a href="https://www.mines.edu/speak-up/" target="_blank">https://www.mines.edu/speak-up/</a>) - Anonymous option</li>
</ul>
</li>
</ul>
<p>In this course, we will cultivate a community that supports survivors, prevents interpersonal violence, and
promotes a harassment free environment. Title IX and Colorado State law protects individuals from
discrimination based on sex and gender in educational programs or activities. Mines takes this obligation
seriously and is committed to providing a campus community free from gender and sex-based
discrimination. Discrimination, including sexual harassment, sexual violence, stalking, and domestic
violence, is prohibited and will not be tolerated within the Mines campus community. If these issues have
affected you or someone you know, you can access the appropriate resources here:
<a href="http://www.mines.edu/title-ix/" target="_blank">http://www.mines.edu/title-ix/</a>. You can also contact the Mines Title IX Coordinator, Camille Torres, at
303-384-2124 or <a href="mailto:titleix@mines.edu">titleix@mines.edu</a> for more information.</p>

<p>It's on us, all of the Mines community, to engineer a culture of respect.</p>

        <h3>Disability Support Services</h3>
        <p>The Colorado School of Mines is committed to ensuring the full participation of all students 
        in its programs, including students with disabilities. If you are registered with Disability 
        Support Services (DSS) and we (your instructors) have received your letter of accommodations, 
        please contact us at your earliest convenience so we can discuss your needs in this course. For 
        questions or other inquiries regarding disabilities, we encourage you to visit
         <a href="https://www.mines.edu/disability-support-services/" target="_blank">https://www.mines.edu/disability-support-services/</a> 
         for more information.</p>


        <h3>Collaboration Policy</h3>
        <p>All students are advised to be familiar with university policy on Academic Integrity. In addition, The following Collaboration Policy exists for all CS@Mines courses. This policy is a minimum standard; your instructor may decide to augment this policy.</p>
        <ol>
            <li>If the project is an individual effort project, you are not allowed to give code you have developed to another student or use code provided by another student. If the project is a group project, you are only allowed to share code with your group members.</li>
            <li>You are encouraged to discuss programming projects with other students in the class, as long as the following rules are followed:</li>
                    <ol type="a">
                        <li>You view another student's code only for the purpose of offering/receiving debugging assistance. Students can only give advice on what problems to look for; they cannot debug your code for you. All changes to your code must be made by you.</li>
                        <li>Your discussion is subject to the empty hands policy, which means you leave the discussion without any record [electronic, mechanical or otherwise] of the discussion.</li>
                    </ol>
            <li>Any material from any outside source such as books, projects, and in particular, from the Web, should be properly referenced and should only be used if specifically allowed for the assignment.</li>
        </ol>

        <p>All issues of misconduct are reported to the Dean of Students.</p>

        <b>Instructor's Addendum</b>
        <p>As an addendum to this policy, you are required to submit a README file with every (non-APT) assignment. The README should list every person (other than the instructor or a TA) who assisted you in some way on the assignment. The README is also the place to give appropriate credit to any outside source that contributed to your submission.</p>

  </div>
</template>

<script>
export default {
  name: 'Policies'
}
</script>
